import { render, staticRenderFns } from "./Syllable.vue?vue&type=template&id=01eeaac6&scoped=true"
import script from "./Syllable.vue?vue&type=script&lang=js"
export * from "./Syllable.vue?vue&type=script&lang=js"
import style0 from "./Syllable.vue?vue&type=style&index=0&id=01eeaac6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01eeaac6",
  null
  
)

export default component.exports